/** Placeholder replaced with the canonical base URL in SEO text and schema. */
export const SEO_BASE_URL_PLACEHOLDER = '__BASE_URL__';
export const SEO_BASE_URL = 'https://www.bluestone.com';
